// SPEC-31 · « PT · FR · EN », the design system's segmented control, on
// Boas-vindas over the photo and on Perfil in the Idioma card. A tap
// changes the language at once; there is no button to confirm it. The
// current segment is white with the segment shadow.
//
// A group of buttons with aria-pressed, each reached by Tab: the group is
// named by the screen (« Idioma »), each segment by what it shows followed
// by its language's own name (« FR Français »): voice control finds it by
// the letters on screen, and a screen reader says the name as it is said.

import { HTML_LANG } from "../i18n/language";
import { useCopy, useLanguage } from "../i18n/LanguageProvider";
import { LANGUAGES } from "../schema/types";

const focusRing = "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet";
/** A segment is drawn 36 px tall; an empty ::before over the track's padding takes a tap 44 px tall (SPEC-47). */
const hitArea = "relative before:absolute before:inset-x-0 before:top-1/2 before:h-[var(--touch-min)] before:-translate-y-1/2";
const segment =
  "flex h-9 touch-manipulation items-center rounded-pill px-3.5 text-body-sm whitespace-nowrap " +
  `transition-colors duration-[var(--dur-micro)] ease-pyf ${hitArea} ${focusRing}`;
const segmentOn = `${segment} bg-white font-semibold text-dark shadow-segment`;
const segmentOff = `${segment} font-medium text-muted hover:text-dark`;

/** `onPhoto`: over Boas-vindas' photo, on cream; otherwise on a white card, on cream-deep. */
export function LanguageControl({ label, onPhoto = false }: { label: string; onPhoto?: boolean }) {
  const { language, setLanguage } = useLanguage();
  const { languages } = useCopy();
  return (
    // translate="no": a page translator would rename the languages, each written in its own.
    <div role="group" aria-label={label} translate="no" className={`flex shrink-0 items-center rounded-pill p-1 ${onPhoto ? "bg-cream" : "bg-cream-deep"}`}>
      {LANGUAGES.map((option) => (
        <button
          key={option}
          type="button"
          lang={HTML_LANG[option]}
          aria-pressed={option === language}
          onClick={() => setLanguage(option)}
          className={option === language ? segmentOn : segmentOff}
        >
          {languages[option].short}
          <span className="sr-only"> {languages[option].name}</span>
        </button>
      ))}
    </div>
  );
}
